// This is a generated file. Any changes made directly in this file will be overwritten.
import * as React from 'react';
import { createSvgIcon } from '@bb-ui/react-library/dist/internal/icons';

export const ShareFile = createSvgIcon(
  { LeftToRight: <React.Fragment><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 1v14M15 5l4-4 4 4M16 8h-2.1716a2 2 0 01-1.4142-.5858l-.8284-.8284A2 2 0 0010.1716 6H5c-1.1046 0-2 .8954-2 2v3" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 11H3.1736c-1.17 0-2.0903 1.0001-1.993 2.1661l.6666 8C1.9336 22.2027 2.8 23 3.8402 23H20.19c1.0275 0 1.8874-.7751 1.9878-1.7977C22.4652 18.2754 23 12.7313 23 12c0-1-1-1-1-1" /></React.Fragment>, },
  'default'
);
